// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"0beb7af5","190":"72eca152","453":"4ab05f2e","562":"607cfed8","726":"19dc7b1f","781":"078539a4","816":"89292497","998":"2ef93494"}[chunkId] + ".chunk.js";
};